import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";
import FragmentDataType from "../enums/fragment-data-type";
import { FragmentMessages } from "../../common/fragment-messages";

/**
 * Rebound Net hit ground fragment for Indoor Football.
 * When the ball hits the rebound net and then hits the ground (ball is dead).
 */
export default class ReboundNetHitGround extends Fragment {
    constructor(deadAt) {
        super();
        this.code = "RBNHG";
        this.deadAt = deadAt;

        this.requiredData = [
            {
                name: "deadAt",
                type: FragmentDataType.FieldPosition,
                displayName: "Dead At",
                title: "Ball Dead At",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION
            }
        ];
    }

    getFieldPosition() {
        return this.deadAt;
    }

    summarize(summaryContext, stringifier) {
        const message = `ball dead at ${stringifier.niceFieldPosition(
            summaryContext.gameConfig.general.fieldLength,
            this.deadAt,
            summaryContext.homeTeam?.abbrName,
            summaryContext.awayTeam?.abbrName
        )}`;
        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        if (this.deadAt || this.deadAt === 0) {
            summaryContext.fieldPosition = this.deadAt;
        }
        summaryContext.eopPrinted = true;
    }

    toJSON() {
        return {
            ...super.toJSON()
        };
    }
}
